import settings from '../liferay/settings';
import ApiUtils from '../liferay/ApiUtils';
import { getLifeRaySiteGroupId } from '../liferay/helper'

/** Специальные действия для получения информации о документах и медиа загруженных в Liferay
 * Например, список каталогов
 */
export const DMLActions = {
  EMPTY: () => ({
    type: "DMLActions.EMPTY"
  }),
  LOAD_STARTED: () => ({
    type: "DMLActions.LOAD_STARTED"
  }),
  LOAD_ERROR: (error) => ({
    type: "DMLActions.LOAD_ERROR",
    error,
  }),
  ITEMS: (items) => ({
    type: "DMLActions.ITEMS",
    items,
  }),
  CHILDREN: (parentId, items) => ({
    type: "DMLActions.CHILDREN",
    parentId, items,
  }),
  SELECTED: (item) => ({
    type: "DMLActions.SELECTED",
    item,
  }),

  /** Загрузить список доступных wiki узлов */
  loadItems: (folderId=0, offset=0, limit=100, status=0) => dispatch => {
    //console.log('initialization', table);
    //Сделаем событие, что начали загружать данные 
    dispatch(DMLActions.LOAD_STARTED());
    const options = {...settings.options};
    const formData = {
      'cmd': JSON.stringify({'/dlfolder/get-folders-and-file-entries-and-file-shortcuts':{}}),
      'formDate': new Date().getMilliseconds(),
      'groupId': getLifeRaySiteGroupId(),
      'folderId': folderId,
      'status': status,
      'includeMountFolders': true,
      'start': offset,
      'end': offset+limit,
      '-obc':'',
      '-orderByComparator': '',
    }
    return ApiUtils.postToLifeRay721(formData, options)
      .then ((response) =>{
        console.log("Done!", response);
        //const { count, items, years} = response;
        dispatch(DMLActions.ITEMS(response));
        return Promise.resolve(response);
      })
      .catch(e => { 
        dispatch(DMLActions.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        return Promise.reject(e);
      });
  },

  /** Загрузить список доступных папок и файлов  для узла  */
  loadChildern: (folderId, offset=0, limit=200, status=0) => dispatch => {
    //Сделаем событие, что начали загружать данные 
    dispatch(DMLActions.LOAD_STARTED());
    const options = {...settings.options};
    const formData = {
      'cmd': JSON.stringify({'/dlfolder/get-folders-and-file-entries-and-file-shortcuts':{}}),
      'formDate': new Date().getMilliseconds(),
      'groupId': getLifeRaySiteGroupId(),
      'folderId': folderId,
      'status': status,
      'includeMountFolders': true,
      'start': offset,
      'end': offset+limit,
      '-obc':'',
      '-orderByComparator': '',
    }
    return ApiUtils.postToLifeRay721(formData, options)
      .then ((response) =>{
        console.log("Done!", response);
        //const { count, items, years} = response;
        dispatch(DMLActions.CHILDREN(folderId, response));
        return Promise.resolve(response);
      })
      .catch(e => { 
        dispatch(DMLActions.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        return Promise.reject(e);
      });
  },

};
